import _ from "lodash";

export const NAME = "analytics";

export interface AggregatedMetrics {
  spend: number;
  impressions: number;
  opens: number;
  unique_engaged_visits: number;
  clicks: number;
  shopping_list: number;
  ttm: number;
  time_on_flyer: number;
  page_views: number;
  item_views: number;
}

export interface AnalyticsGlobalFilters {
  device: DeviceFilter[];
  channel: ChannelFilter[];
  [key: string]: DeviceFilter[] | ChannelFilter[];
}

export declare type ChannelFilter = "hosted" | "distribution";

export declare type DeviceFilter = "mobile" | "desktop";

export const validateGlobalFilters = (
  globalFilters: AnalyticsGlobalFilters
) => {
  const { device, channel } = globalFilters;
  const defaultDevices = defaultGlobalFilters.device;
  const defaultChannels = defaultGlobalFilters.channel;
  const validDevices = device.every((device: DeviceFilter) =>
    defaultDevices.includes(device)
  );
  const validChannels = channel.every((channel: ChannelFilter) =>
    defaultChannels.includes(channel)
  );
  return validChannels && validDevices;
};

export const defaultGlobalFilters = {
  device: ["mobile", "desktop"],
  channel: ["hosted", "distribution"]
};
export interface Publication {
  flyer_run_id: any;
  flyer_run_name: string;
  available_from: string;
  flyer_type_name: string;
  available_to: string;
  m_thumbnail: string;
  l_thumbnail: string;
  xl_thumbnail: string;
}



// WEBPACK FOOTER //
// ./client/modules/Analytics/constants.ts